module.exports = __webpack_public_path__ + "img/third_trophy.e6ec8a60.svg";